import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { actions, selectors } from 'darwin_core';

// The global surface for control commands that fail loudly. darwin_core only
// raises explicit error records for holiday and publish commands (pending-reducer
// gives mode/setpoint an undefined errorLabel, so those revert silently); this
// banner shows those records and lets the user dismiss them.
//
// getPendingErrors de-dupes by requestId across the pending slices. Each record
// carries a human message and the requestId dismissError keys on. role="alert"
// so the failure is announced immediately.
export default function ControlErrorBanner() {
  const dispatch = useDispatch();
  // getPendingErrors rebuilds its array each call but reuses the underlying error
  // records, so a shallow comparator keeps this from re-rendering (and tripping
  // useSelector's stability check) on every unrelated store change.
  const errors = useSelector(selectors.getPendingErrors, shallowEqual);

  if (!errors || errors.length === 0) {
    return null;
  }

  return (
    <div className="control-errors" role="alert">
      <ul className="control-errors__list">
        {errors.map((error) => (
          <li key={error.requestId} className="control-errors__item">
            <span className="control-errors__message">{error.message}</span>
            <button
              type="button"
              className="btn-secondary control-errors__dismiss"
              onClick={() => dispatch(actions.dismissError(error))}
            >
              Dismiss
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
